import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ApiError } from "@/api";
import { App } from "@/App";
import { restorePreview } from "@/lib/preview";
import { applyTheme, storedTheme } from "@/lib/theme";
import "./styles.css";

applyTheme(storedTheme());
restorePreview();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 4xx won't fix itself; network and server hiccups get two more tries.
      retry: (failures, error) => !(error instanceof ApiError && error.status < 500) && failures < 2,
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
